module.exports = __webpack_public_path__ + "static/shot2-b74723631d6db90802b3b2df40ab1465.png";